import { Component, OnInit } from '@angular/core';
import { BaseUpdateComponent, BaseDataService, NotificationService } from 'yt-ng-framework';
import { OsobaTelefon } from './osoba-telefon';
import { ActivatedRoute } from '@angular/router';
// import { NotificationsService } from 'angular2-notifications';
import { Validators } from '@angular/forms';
import { TranslateService } from '@ngx-translate/core';
// import { ToastrService } from 'ngx-toastr';

@Component({
  selector: 'yt-osoba-telefon-update',
  templateUrl: './osoba-telefon-update.component.html'
})
export class OsobaTelefonUpdateComponent
extends BaseUpdateComponent<OsobaTelefon>
 implements OnInit {

  constructor(
    protected activatedRoute: ActivatedRoute,
    protected baseDataService: BaseDataService,
    // protected notificationsService: NotificationsService,
    protected toastrService: NotificationService,
    protected translateService: TranslateService
  
  ) { 
    super(activatedRoute, baseDataService, toastrService, translateService);
  }

  ngOnInit() {
    super.ngOnInit();
    this.addValidatorToFc("Broj", Validators.required, 'required', 'OSOBATELEFON.BROJ.VALIDATION.REQUIRED');
    this.addValidatorToFc("Broj", Validators.maxLength(50), 'maxlength', 'OSOBATELEFON.BROJ.VALIDATION.MAXLENGTH');
    this.addValidatorToFc("Lokal", Validators.maxLength(4), 'maxlength', 'OSOBATELEFON.LOKAL.VALIDATION.MAXLENGTH');
    this.addValidatorToFc("Opis", Validators.maxLength(100), 'maxlength', 'OSOBATELEFON.OPIS.VALIDATION.MAXLENGTH');
    this.addValidatorToFc("SvojinaID", Validators.required, 'required', 'OSOBATELEFON.SVOJINA.VALIDATION.REQUIRED');
    this.addValidatorToFc("VrstaTelefonaID", Validators.required, 'required', 'OSOBATELEFON.VRSTATELEFONA.VALIDATION.REQUIRED');
  }

}
